<template>
  <div class="trajectory-clip-container">
    <div class="trajectory-clip-switch">
      <span class="switch-label">保留反选</span>
      <el-switch v-model="keepInverse" size="small" />
    </div>
    <el-button type="primary" size="small" @click="handleConfirm" :loading="loading">确认</el-button>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { message } from '@/utils/js/initVariable';
import { clipTrajectory } from '@/api/UserWorkspaceApi';

const props = defineProps({
  layer: { type: Object, required: true },
  workSpaceDataList: { type: Array, default: () => [] },
  onSuccess: { type: Function, default: () => {} },
});
const emit = defineEmits(['close']);

const keepInverse = ref(false);
const loading = ref(false);

const handleConfirm = () => {
  const checkList = props.workSpaceDataList.filter(
    e => e['check'] && (e['dataType'] || '').includes('track')
  );
  if (checkList.length === 0) {
    message('请先勾选轨迹数据', 2);
    return;
  }
  const dataIds = checkList.map(e => e['id']);
  const geojson = JSON.stringify(props.layer.toGeoJSON());
  const type = keepInverse.value ? 0 : 1;

  loading.value = true;
  clipTrajectory({ geojson, type, dataIds }).then(res => {
    if (res.data.code == 1004) {
      message(res.data.msg, 1);
      props.onSuccess(dataIds);
      emit('close');
    }
    loading.value = false;
  }).catch(err => {
    loading.value = false;
    console.log(err);
  });
};
</script>

<style lang='less' scoped>
.trajectory-clip-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  .trajectory-clip-switch {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .switch-label {
      font-size: 13px;
      color: var(--fontColor_5);
    }
  }
}
</style>
